
<div>
    <v-row class="no-frame">
        <v-col class="no-frame mr-2">
            <f-date-picker
                label           = "inc.edit.common.unitdown.start"
                :time           = "true"
                :rules          = "[fromRule]"
                v-model         = "unitdata.unitDownBegin"
                :error-messages = "error.begin"
                @change         = "onChangeStart"
            />
        </v-col>
        <v-col class="no-frame ml-2">
            <f-date-picker
                label           = "inc.edit.common.unitdown.end"
                :time           = "true"
                :rules          = "[toRule]"
                v-model         = "unitdata.unitDownEnd"
                :error-messages = "error.end"
                @change         = "onChangeEnd"
            />
        </v-col>
    </v-row>
</div>
